import { Bridge } from '@mc/mc-jsbridge'
import { Ssu } from './ssu'
import { loginConfirm } from '@/utils/native_interactions/login'
import { Toast } from 'vant'
import Url from '@mc/mc-utils/js/url/url'
class Cart {
  totalAmount = 0
  packageDesc = ''
  _subscriberIdCounter = 0
  goods = []
  _subscribers = {}

  constructor(config) {
    const { autoSync, requests } = config
    this.config = {
      requests
    }
    // 需要闭包的方法定义
    this.debounceAdd = (() => {
      let timeout
      let cache = []
      return (uniqueId, totalPrice) =>
        new Promise((resolve, reject) => {
          timeout && clearTimeout(timeout)
          const cachedItem = cache.find(item => item.unique_id === uniqueId)
          if (cachedItem) {
            cachedItem.num += 1
            cachedItem.totalPrice = totalPrice
          } else {
            cache.push({
              unique_id: uniqueId,
              num: 1,
              totalPrice
            })
          }
          timeout = setTimeout(async () => {
            try {
              const cacheSnapShot = [...cache]
              cache = []
              const res = await this.add(cacheSnapShot)
              resolve(res)
            } catch (error) {
              /* istanbul ignore next */
              reject(error)
            }
          }, 500)
        })
    })()
    this.debounceSubtract = (() => {
      let timeout
      let cache = []
      return (uniqueId, totalPrice) =>
        new Promise((resolve, reject) => {
          timeout && clearTimeout(timeout)
          const cachedItem = cache.find(item => item.unique_id === uniqueId)
          if (cachedItem) {
            cachedItem.num += 1
            cachedItem.totalPrice = totalPrice
          } else {
            cache.push({
              unique_id: uniqueId,
              num: 1,
              totalPrice
            })
          }
          timeout = setTimeout(async () => {
            try {
              const res = await this.subtract(cache)
              cache = []
              resolve(res)
            } catch (error) {
              /* istanbul ignore next */
              reject(error)
            }
          }, 500)
        })
    })()
    /* istanbul ignore else */
    if (autoSync) {
      this.sync()
    }
    // native 事件注册
    this.nativeInteractionEventRegister()
  }

  get goodsAmount() {
    return Object.values(this.goods)
      .map(good => good.count)
      .reduce((prev, cur) => prev + cur, 0)
  }

  get selectedGoodsAmount() {
    return Object.values(this.goods)
      .map(good => (good.selected ? good.count : 0))
      .reduce((prev, cur) => prev + cur, 0)
  }

  getByUniqueId(uniqueId, { hasSubscribed = false } = {}) {
    this.goods[uniqueId] =
      this.goods[uniqueId] ?? new Ssu({ uniqueId, hasSubscribed })
    return this.goods[uniqueId]
  }

  async sync() {
    try {
      const res = await this.config.requests.list()
      // !!! istanbul 计算 optional chaining 和 nullish coalescing operator 的时候有问题，只能暂且 ignore，写的时候请小心。
      /* istanbul ignore next */

      this.totalAmount = res?.total_amount ?? this.totalAmount
      this.packageDesc = res?.package_desc || this.packageDesc
      const existGoodsUniqueIds = []
      /* istanbul ignore next */
      res?.delivery_list?.forEach?.(delivery => {
        delivery.activity_group?.forEach?.(activity => {
          activity.goods_list?.forEach?.(good => {
            existGoodsUniqueIds.push(good.unique_id)
            const ssu = this.getByUniqueId(good.unique_id)
            ssu.update({
              skuId: good.sku_id ?? ssu.skuId,
              ssuId: good.ssu_id ?? ssu.ssuId,
              count: good.num ?? ssu.count,
              selected: !!good.status,
              statusRemindInfo: good.status_remind_info ?? ssu.statusRemindInfo,
              promotionRemindInfo:
                good.promotion_remind_info ?? ssu.promotionRemindInfo,
              purchasePriceRemindInfo:
                good.purchase_price_remind_info ?? ssu.purchasePriceRemindInfo,
              packages: good.packages ?? ssu.packages
            })
          })
        })
      })
      Object.keys(this.goods).forEach(uniqueId => {
        if (existGoodsUniqueIds.indexOf(uniqueId) === -1) {
          this.goods[uniqueId].update({
            count: 0,
            selected: false,
            buySkuNumMsg: '',
            statusRemindInfo: {},
            promotionRemindInfo: {},
            purchasePriceRemindInfo: {},
            packages: []
          })
        }
      })
      Object.values(this._subscribers).forEach(handler => {
        handler()
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async put(params) {
    try {
      const res = await this.config.requests.put(params)
      const modifyMsg = res?.put_goods_price_modify_msg || ''
      if (modifyMsg) {
        Toast({
          message: modifyMsg
        })
      }
      /* istanbul ignore next */
      this.totalAmount = res?.total_amount || this.totalAmount
      this.packageDesc = res?.package_desc || this.packageDesc
      const isZeroGoods = []
      params.ssu_list.forEach(item => {
        /* istanbul ignore next */
        const notZeroItem = res?.light_cart_ssus?.find(
          ssu => ssu.unique_id === item.unique_id
        )
        if (!notZeroItem) {
          isZeroGoods.push(item)
        }
      })
      isZeroGoods.forEach(item => {
        const ssu = this.getByUniqueId(item.unique_id)
        ssu.update({
          count: 0
        })
      })
      /* istanbul ignore next */
      res?.light_cart_ssus?.forEach?.(good => {
        const ssu = this.getByUniqueId(good.unique_id)
        ssu.update({
          skuId: good.sku_id ?? ssu.skuId,
          ssuId: good.ssu_id ?? ssu.ssuId,
          count: good.num ?? ssu.count,
          selected: true,
          buySkuNumMsg: good.buy_sku_num_msg ?? ssu.buySkuNumMsg,
          statusRemindInfo: good.status_remind_info ?? ssu.statusRemindInfo,
          promotionRemindInfo:
            good.promotion_remind_info ?? ssu.promotionRemindInfo,
          purchasePriceRemindInfo:
            good.purchase_price_remind_info ?? ssu.purchasePriceRemindInfo,
          packages: good.packages ?? ssu.packages
        })
      })
      this.noticeNativeAddCart(params.ssu_list)
      Object.values(this._subscribers).forEach(handler => {
        handler()
      })
      return res
    } catch (error) {
      if (
        error?.res?.error?.code === 1012002 ||
        error?.res?.error?.code === 2003 ||
        error?.res?.error?.code === 1013014
      ) {
        loginConfirm()
      }

      return Promise.reject(error)
    }
  }

  async add(params) {
    const url = new Url(window.location.href)
    const query = url.parseQuerystring()
    const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
    const deliveryKey = query.deliveryKey || hashQuery.deliveryKey || ''
    let deliveryKeys = []
    if (deliveryKey) {
      deliveryKeys = deliveryKey.split(',')
    }
    const ssuList = params.map(item => {
      const ssu = this.getByUniqueId(item.unique_id)
      return {
        unique_id: item.unique_id,
        num: item.num + ssu.count,
        put_goods_price: item?.totalPrice || '',
        delivery_keys: deliveryKeys
      }
    })
    return this.put({
      ssu_list: ssuList
    })
  }

  async subtract(params) {
    const url = new Url(window.location.href)
    const query = url.parseQuerystring()
    const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
    const deliveryKey = query.deliveryKey || hashQuery.deliveryKey || ''
    let deliveryKeys = []
    if (deliveryKey) {
      deliveryKeys = deliveryKey.split(',')
    }
    const ssuList = params.map(item => {
      const ssu = this.getByUniqueId(item.unique_id)
      const num = ssu.count - item.num
      return {
        unique_id: item.unique_id,
        num: num > 0 ? num : 0,
        put_goods_price: item?.totalPrice || '',
        delivery_keys: deliveryKeys
      }
    })
    return this.put({
      ssu_list: ssuList
    })
  }

  async subscribe(ssuId) {
    try {
      const res = await this.config.requests.subscribe({
        ssu_id: ssuId
      })
      const ssu = this.getByUniqueId(ssuId)
      ssu.update({
        hasSubscribed: true
      })
      this.noticeNativeSubscribe(ssuId)
      Object.values(this._subscribers).forEach(handler => {
        handler()
      })
      return res
    } catch (error) {
      /* istanbul ignore next */
      return Promise.reject(error)
    }
  }

  onChange(handler) {
    const id = ++this._subscriberIdCounter
    Object.assign(this._subscribers, {
      [id]: handler
    })
    return id
  }

  removeChangeHandler(id) {
    this._subscribers[id] && delete this._subscribers[id]
  }

  nativeInteractionEventRegister() {
    /* istanbul ignore else */
    if (Bridge.prepared) {
      let timeout = 0
      Bridge.register('mcsc.onCartEvent', () => {
        timeout && /* istanbul ignore next */ clearTimeout(timeout)
        timeout = setTimeout(() => {
          this.sync()
        }, 500)
      })
      Bridge.register('mcsc.onAddArrivedNotice', res => {
        /* istanbul ignore else */
        if (typeof res === 'string') {
          try {
            const obj = JSON.parse(res)
            const uniqueIds = Array.isArray(obj.unique_ids)
              ? obj.unique_ids
              : typeof obj.unique_ids === 'string'
              ? obj.unique_ids.split(',')
              : /* istanbul ignore next */ []
            uniqueIds.forEach(uniqueId => {
              const ssu = this.getByUniqueId(uniqueId.trim())
              ssu.update({
                hasSubscribed: true
              })
            })
          } catch (error) {}
        }
      })
    }
  }

  noticeNativeAddCart(ssus) {
    /* istanbul ignore else */
    if (Bridge.prepared) {
      ssus.forEach(ssu => {
        Bridge.call('mcsc.addcart', {
          ssuId: ssu.unique_id,
          ssuNum: ssu.num
        })
      })
    }
  }

  noticeNativeSubscribe(uniqueId) {
    /* istanbul ignore else */
    if (Bridge.prepared) {
      Bridge.call('mcsc.addArrivedNotice', {
        uniqueId
      })
    }
  }
}

export { Cart }
